export default __webpack_public_path__ + "static/media/Rectangle_175.f2063c44.png";